import React from 'react';
import axios from 'axios';
import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';
import { Form, Header, Segment, Loader } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { fetchAcademicYears, fetchStudyCycle, fetchPreviousAcademicYear } from '../Lookups/util';
import { legendStyle, customLabel, DEFAULT_CHART_COLORS as colors, center } from './util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class GraduatedStudentsPerStudyCycleForUniversity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            academicYears: [],
            academicYear: '',
            data: [],
            studyCycles: [],
            previousAcademicYear: '',

            loading: true,
            showChart: false
        };

        this.fetchAcademicYearsAndStudyCycle = this.fetchAcademicYearsAndStudyCycle.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
        this.getNumberOfAllGraduatedStudents = this.getNumberOfAllGraduatedStudents.bind(this);
        this.getStudyCycleName = this.getStudyCycleName.bind(this);
        this.countAllStudents = this.countAllStudents.bind(this);
    }

    componentDidMount() {
        this.fetchAcademicYearsAndStudyCycle();
        this.generateChartData(this.state.previousAcademicYear);
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }

    getNumberOfAllGraduatedStudents() {
        const { data } = this.state;
        let numberOfAllGraduatedStudents = 0;
        for (let i = 0; i < data.length; i + 1) { numberOfAllGraduatedStudents += data[i].value; }
        return numberOfAllGraduatedStudents;
    }

    countAllStudents() {
        const { data } = this.state;
        return data.reduce((a, c) => a + c.value, 0);
    }

    fetchAcademicYearsAndStudyCycle() {
        axios.all([fetchAcademicYears(), fetchStudyCycle(), fetchPreviousAcademicYear()])
            .then(axios.spread((academicYearsRes, studyCyclesRes, previousAcademicYearRes) => {
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const previousAcademicYear = previousAcademicYearRes.data.id;
                const studyCycles = studyCyclesRes.data.map(el => ({ ...el, value: el.id, name: el.name }));
                this.setState({
                    academicYears, academicYear: previousAcademicYear, studyCycles, loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch academic years or study cycles');
            });
        this.generateChartData(this.state.previousAcademicYear);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    generateChartData(academicYear) {
        axios.get(`/statistics/graduated-per-study-cycle-for-university?academicYearId=${academicYear}`)
            .then(res => {
                const data = res.data.map(el => ({ ...el, name: this.getStudyCycleName(el.studyCycleId), value: el.numberOfStudents }));
                this.setState({ data, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }
    render() {
        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectAcademicYear" />}
                        </Header>
                    </Segment><Segment>
                        <Form>
                            <Form.Group widths="equal">

                                <Form.Field>
                                    <label>{<FormattedMessage id="common.academicYear" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Button label=" " color="blue" basic="true" onClick={() => this.generateChartData(this.state.academicYear)}>{<FormattedMessage id="common.show" />}</Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.state.showChart && <Segment.Group raised>
                    <Segment raised >
                        <Header as="h2">
                            {<FormattedMessage id="common.unsa" />}
                        </Header>
                        <Header as="h3">{<FormattedMessage id="statistics.headerNumberGraduatedStudentsPerStudyCycles" />} {this.getAcademicYearName()} {<FormattedMessage id="statistics.headerAcademicYear" />} </Header>

                    </Segment>
                    {data.length ? <div><Segment>
                        <br />

                        <PieChart style={center} width={890} height={400}>
                            <Pie
                                isAnimationActive
                                label={customLabel}
                                data={data}
                                cx={300}
                                cy={160}
                                outerRadius={120}
                                innerRadius={30}
                            >
                                {
                                    data.map((entry, index) => <Cell fill={colors[index % colors.length]} />)
                                }
                            </Pie>
                            <Legend iconType="circle" iconSize={15} width={160} height={140} layout="vertical" align="left" verticalAlign="bottom" wrapperStyle={legendStyle} />
                            <Tooltip />
                        </PieChart>
                        <br />
                    </Segment><Segment>
                        <h3> {<FormattedMessage id="statistics.studentsNumber" />}  {this.countAllStudents()}</h3>
                    </Segment></div>
                        : <Segment>
        Nema podataka na ovom fakultetu za odabranu akademsku godinu.
                        </Segment>}
                </Segment.Group>}
            </div>
        );
    }
}
export default GraduatedStudentsPerStudyCycleForUniversity;



// WEBPACK FOOTER //
// ./src/views/Statistics/GraduatedStudentsPerStudyCycleForUniversity.js